// extracted by mini-css-extract-plugin
module.exports = {"Power":"Power_Power__TxF7V"};